export default "__VITE_ASSET__CcTVqtw7__"